import { IOnInit } from "angular";
import {
  MachineConfiguration,
  MachineGameConfiguration,
} from "../../../../../models/machineConfiguration";
import {
  MachineConfigurationProgressiveInformation,
  MachineGameConfigurationLevel,
  MachineGameConfigurationProgressiveGameInformation,
} from "../../../../../models/progressiveDefinition";

type ErrorSetLookup = { [id: number]: ErrorSet };
type ErrorSet = { [errorKey: string]: {} };

export class MachineDetailProgressiveConfigurationGameInfoComponentController
  implements IOnInit
{
  static $inject = [];

  readonly machineConfiguration!: MachineConfiguration;
  readonly machineConfigurationProgressiveInformation:
    | MachineConfigurationProgressiveInformation
    | undefined;

  constructor() {}

  private matchErrors: ErrorSetLookup | undefined;

  $onInit(): void {
    this.matchErrors =
      this.machineConfigurationProgressiveInformation?.Games.reduce(
        (
          result: ErrorSetLookup,
          next: MachineGameConfigurationProgressiveGameInformation
        ) => {
          const errorSet: ErrorSet = (result[next.MachineGameConfigurationId] =
            {});

          const gameConfiguration: MachineGameConfiguration =
            this.getMachineGameConfiguration(next)!;

          const paytableId = gameConfiguration.PaytableId;
          const gameProgramNumber = gameConfiguration.GameProgramNumber;

          let gameConfigError = false;

          if (!paytableId) {
            errorSet["noPaytableSlotGame"] = true;
            gameConfigError = true;
          }
          if (!gameProgramNumber) {
            errorSet["noGameProgramSlotGame"] = true;
            gameConfigError = true;
          }

          if (gameConfigError) {
            return result;
          }

          const matchingProgressiveGamesByPaytableAndGameProgramNumber =
            this.machineConfigurationProgressiveInformation?.Games?.filter(
              (g) =>
                g.ProgressiveDefinitionGame?.GameProgramNumber ===
                  gameProgramNumber &&
                g.ProgressiveDefinitionGame?.PaytableId == paytableId
            ) ?? [];

          if (
            matchingProgressiveGamesByPaytableAndGameProgramNumber.length === 0
          ) {
            errorSet["paytableGameProgramMiss"] = true;
          } else if (next.ProgressiveDefinitionGame === undefined) {
            errorSet["unknownMiss"] = true;
          }

          return result;
        },
        {}
      ) ?? {};
    const x = this.matchErrors;
    return;
  }

  getMatchErrors(
    game: MachineGameConfigurationProgressiveGameInformation
  ): ErrorSet {
    if (this.matchErrors === undefined) return {};
    return this.matchErrors[game.MachineGameConfigurationId];
  }

  hasMatchErrors(
    game: MachineGameConfigurationProgressiveGameInformation
  ): boolean {
    if (this.matchErrors === undefined) return false;

    const gameErrors = this.getMatchErrors(game);
    return (
      Object.entries(gameErrors).filter((entry) => entry[1] === true).length > 0
    );
  }

  getMachineGameConfiguration(
    game: MachineGameConfigurationProgressiveGameInformation
  ): MachineGameConfiguration | undefined {
    return this.machineConfiguration.GamesConfig?.find(
      (gc) => gc.Id === game.MachineGameConfigurationId
    );
  }

  get pi(): MachineConfigurationProgressiveInformation | undefined {
    return this.machineConfigurationProgressiveInformation;
  }

  getLevelTotalContribution(level: MachineGameConfigurationLevel) {
    const progressiveDefinitionGameLevel =
      level?.ProgressiveDefinitionGameLevel ?? {};
    if (
      progressiveDefinitionGameLevel.Contribution === undefined &&
      progressiveDefinitionGameLevel.HiddenContribution === undefined
    ) {
      return undefined;
    }

    return (
      (progressiveDefinitionGameLevel.Contribution ?? 0) +
      (progressiveDefinitionGameLevel.HiddenContribution ?? 0)
    );
  }

  getGameTotalContribution(
    game: MachineGameConfigurationProgressiveGameInformation
  ) {
    var gameLevels = game?.Levels ?? [];
    if (
      !gameLevels.find(
        (gl) =>
          gl?.ProgressiveDefinitionGameLevel?.Contribution ||
          gl?.ProgressiveDefinitionGameLevel?.HiddenContribution
      )
    ) {
      return undefined;
    }

    return gameLevels.reduce(
      (result, next) => result + (this.getLevelTotalContribution(next) ?? 0),
      0
    );
  }
}
